import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyA9MssNCkDsiKbu_wqAE0FjxmiCQ5N1Iow",
  // ✅ Updated to your custom domain to allow live logins
  authDomain: "virtualassistantacademypro.com",
  projectId: "virtualassistpro-admin",
  storageBucket: "virtualassistpro-admin.firebasestorage.app", 
  messagingSenderId: "456848583658",
  appId: "1:456848583658:web:f7c187029ccde67d69a093",
};

// Main App Initialization
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");

// Secondary Auth Instance (Used for adding students without logging admin out)
const secondaryApp = initializeApp(firebaseConfig, "secondary");
export const secondaryAuth = getAuth(secondaryApp);